import { IApiPromise } from "@/interfaces/responseData";
import { Subscription } from "../apiRoutes/routes";
import api from "@/interceptors";
import {
  ICustomerSessionIdRespoinse,
  ICustomerSessionRespoinse,
  IgetOrgSubsPlanRespoinse,
} from "@/interfaces/subscipsions/subscriptionsInterfaces";
import { urlApp } from "@/utils/constants";

export const getSessionPortal = (
  returnUrl: string,
): IApiPromise<ICustomerSessionRespoinse> =>
  api.post(Subscription.getSessionPortal as any, {
    returnUrl: `${urlApp}/${returnUrl}`,
  });

export const getSessionId = (): IApiPromise<ICustomerSessionIdRespoinse> =>
  api.get(Subscription.getSessionId as any);

export const getOrgSubsPlan = (): IApiPromise<IgetOrgSubsPlanRespoinse> =>
  api.get(Subscription.getOrgSubsPlan as any);
